import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';

import * as historyActions from 'redux/modules/history';

import { initializeWithKey } from 'redux-form';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
import { isLoaded as isHistoryLoaded, loadHistory } from 'redux/modules/history';

var _ = require('underscore');

import { HistoryList } from 'components';
import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {

    const promises = [];
    //promises.push(dispatch(loadGroups(params)));
    promises.push(dispatch(loadHistory(params)));
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    history: state.history.data,
    error: state.history.error,
    loading: state.history.loading,
    user: state.auth.user,
  }),
  { ...historyActions, initializeWithKey })

export default class History extends Component {


  componentDidMount() {
    //this.props.cancelEdit();
  }

  /*componentWillUnmount(){
  	this.props.clearProducts();
  }*/

  render() {


    const handleLoad = (page) => {
      const { loadHistory } = this.props; // eslint-disable-line no-shadow
      return () => loadHistory(this.props.params);
    };



    const {
      history, params, loading, user, error, t
    } = this.props;




    let refreshClassName = 'fa fa-refresh';
    if (loading) {
      refreshClassName = 'fa fa-refresh fa-spin';
    }
    const styles = require('./History.scss');




    return (
      <div className={styles.products + ' container'}>
        <div>
          <h1>
            {t("historyList.history")}&nbsp;
	          <button className={styles.refreshBtn + ' btn btn-success'} onClick={handleLoad()}>
              <i className={refreshClassName} /> {' '}
            </button>
          </h1>
        </div>

        <Helmet title={t("historyList.history")} />
        <Row>
          <Col md={12} >
            <HistoryList history={history} user={user} params={params} />
          </Col>
        </Row>



        <Row>
          <Col md={3} >
            {error &&
              <div className="alert alert-danger" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                {t("main.connection_error")}
              </div>}
          </Col>
        </Row>
      </div>
    );
  }
}